import { useTranslation } from 'react-i18next';
import { baseLang } from '../../../../../../lib/utils';
import { Row, Col, Input, Label } from 'reactstrap';

export const VideoNamesInputs: React.FC<{
  selectedFileNames: {
    filename_en?: string;
    filename_uk?: string;
    filename_ru?: string;
    playlist_pos?: number;
  };
  setSelectedFileNames: React.Dispatch<
    React.SetStateAction<{
      filename_en?: string;
      filename_uk?: string;
      filename_ru?: string;
      playlist_pos?: number;
    }>
  >;
  takenPlaylistPositions: number[];
}> = ({ selectedFileNames, setSelectedFileNames, takenPlaylistPositions }) => {
  const { t } = useTranslation();

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setSelectedFileNames((prev) => ({ ...prev, [name]: value }));
  };
  return (
    <Row className="mb-3">
      <Col>
        <h5>{t('video.videoName')}</h5>
        {Object.entries(selectedFileNames).map(([key, value]) => {
          if (key === 'playlist_pos') return null;
          return (
            <>
              <Label key={key} className="mt-2">
                {t(`video.filename_${key.split('_')[1]}`)}
              </Label>
              <Input
                key={key}
                type="text"
                name={key}
                value={String(value || '')}
                onChange={handleInputChange}
                placeholder={t('video.videoNamePlaceholder')}
                className="mb-2"
              />{' '}
            </>
          );
        })}
        {takenPlaylistPositions.length > 0 && (
          <div className="mt-3">
            {/* <h6>
              {t('video.takenPlaylistPositions', { positions: takenPlaylistPositions.join(', ') })}
            </h6> */}
            <Label className="text-muted">
              {t('video.providePlaylistPosition', {
                maxPosition: 10,
              })}
            </Label>
            <p className="text-muted">
              {t('video.providePlaylistPositionDescription', {
                positions: takenPlaylistPositions.join(', '),
                maxPosition: 10,
              })}
            </p>
            <Input
              type="number"
              name="playlist_pos"
              min={1}
              max={10}
              onChange={handleInputChange}
              value={String(selectedFileNames?.playlist_pos) || ''}
              placeholder={t('video.playlistPositionPlaceholder')}
            />
          </div>
        )}
      </Col>
    </Row>
  );
};
